export default __webpack_public_path__ + "static/Bitter-Regular-01c5904d6dfb87b5fee95c394ca5b9ae.woff2";